import Model, { attr, belongsTo } from '@ember-data/model';
import { validator, buildValidations } from '@eflexsystems/ember-tracked-validations';
import { isBelongsToRefDirty, rollbackBelongsTo } from 'eflex/util/relationship-helpers';
import { getHardwareType } from 'eflex/helpers';
import { hardwareTypes } from 'eflex/constants/hardware-types';
import { getOwner } from '@ember/application';

@buildValidations({
  tag: [
    validator('presence', {
      presence: true,
      get disabled() {
        return getHardwareType(this.model) !== hardwareTypes.opcUa;
      },
    }),
  ],
  requiredValue: [
    validator('presence', {
      presence: true,
      get disabled() {
        return getHardwareType(this.model) !== hardwareTypes.opcUa;
      },
    }),

    validator('inline', {
      validate(requiredValue, options, oeeHardwareInput) {
        const duplicateValue = oeeHardwareInput.oeeButton.station.oeeButtons
          .filter((button) => button.id !== oeeHardwareInput.oeeButton.id)
          .some((button) => {
            return button.oeeHardwareInput?.requiredValue === requiredValue &&
              button.oeeHardwareInput?.tag === oeeHardwareInput.tag &&
              button.oeeHardwareInput?.hardware === oeeHardwareInput.hardware;
          });

        if (duplicateValue) {
          return getOwner(oeeHardwareInput).lookup('service:intl').t('validations.noDuplicateOeeValue');
        }

        return true;
      },

      get disabled() {
        return !this.model.hardware;
      },
    }),
  ],
})
class OeeHardwareInput extends Model {
  @attr('number') index;
  @attr('string') tag;
  @attr('string') requiredValue;

  @belongsTo('oee-button', { async: false, inverse: 'oeeHardwareInput' }) oeeButton;
  @belongsTo('hardware', { async: false, polymorphic: true, inverse: null }) hardware;
  @belongsTo('hardware-io', { async: false, inverse: null }) input;

  get isDirty() {
    return super.isDirty ||
      isBelongsToRefDirty(this, 'hardware') ||
      isBelongsToRefDirty(this, 'input');
  }

  rollbackAttributes() {
    rollbackBelongsTo(this, 'hardware');
    rollbackBelongsTo(this, 'input');
    super.rollbackAttributes();
  }
}

export default OeeHardwareInput;
